// src/components/ExportCSVButton.js
import React, { useState } from 'react';
import {
    Button,
    CircularProgress,
    Tooltip
} from '@mui/material';
import {
    FileDownload as DownloadIcon,
} from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || '';

const ExportCSVButton = ({ expenseId, variant = "outlined", color = "primary", size = "medium" }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDownload = async () => {
        setLoading(true);
        setError(null);

        try {
            // Pobierz URL z backendu
            const response = await fetch(`${API_URL}/api/expenses/${expenseId}/export-csv`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error('Błąd pobierania CSV');
            }

            // Pobierz zawartość CSV
            const blob = await response.blob();

            // Stwórz link i symuluj kliknięcie
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `dokument_${expenseId}.csv`;
            document.body.appendChild(a);
            a.click();

            // Posprzątaj
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (err) {
            console.error('Error downloading CSV:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title={error || "Pobierz dane dokumentu w formacie CSV"}>
            <span>
                <Button
                    variant={variant}
                    color={error ? "error" : color}
                    onClick={handleDownload}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={20} /> : <DownloadIcon />}
                    size={size}
                >
                    {loading ? "Pobieranie..." : "Eksportuj do CSV"}
                </Button>
            </span>
        </Tooltip>
    );
};

export default ExportCSVButton;